import React from "react"
import styled from "styled-components"
import Section from "../Section"
import { HeadingTwo } from "buoy-core"
import Button from "../Button"
import Symptom from "./components/Symptom"
import responsive from "../../common/responsive"
import { generatePageUrl } from "../../common/utils"


const StyledHeadingTwo = styled(HeadingTwo)`
  text-align: center;
`

const SymptomContainer = styled.div`
  display: flex;
  ${responsive("flex-direction", "row", "row", "row", "column")};
  align-items: center;
  ${responsive(
    "justify-content",
    "space-between",
    "space-between",
    "flex-start",
    "center"
  )};
  ${responsive("overflow-x", "none", "none", "scroll", "none")};
  width: 100%;
  max-width: 980px;
  padding: 10px 0 20px;
`

const Symptoms = ({ headline, button, sections, symptomsAtoZPath }) => (
  <Section color="neutralLightest">
    <StyledHeadingTwo>{headline}</StyledHeadingTwo>
    <SymptomContainer>
      {sections.map((s, i) => <Symptom key={s.headline} {...s} />)}
    </SymptomContainer>
    <Button large href={generatePageUrl(symptomsAtoZPath)}>
      {button}
    </Button>
  </Section>
)

export { Symptoms as default }



// WEBPACK FOOTER //
// ./src/components/Symptoms/index.js